import { ASSETS_URL, ReviewProduct, ReviewType, VideoReview } from '../../types';
import subs from '@/static/assets/reviews/Mary/subs.vtt';
import poster from '@/static/assets/reviews/Mary/video.jpg';

export const Mary: VideoReview = {
  type: ReviewType.Video,
  product: [ReviewProduct.Car],
  reviewerName: 'Mary',
  videoUrl: `${ASSETS_URL}/car/Mary.webm`,
  posterUrl: poster,
  captionsUrl: subs,
};
